import { toFarsiNumber } from "@utils/digits";
import classNames from "classnames";

interface Props {
  discount: number | "wonder";
  className?: string;
  showDiscountTitle?: boolean;
}
const DiscountBadge: React.FC<Props> = ({
  discount,
  className,
  showDiscountTitle = false,
}) => {
  return (
    <div
      className={classNames(
        "bg-fds-danger px-0.5 md:px-1 h-4 md:h-5 max-h-4 md:max-h-5 overflow-hidden flex items-center justify-center  rounded-2",
        className
      )}
    >
      <p className="sm:body-sm body-xxsm text-fds-on-danger text-center align-middle font-normal">
        {discount === "wonder" ? "شگفتی" : `${toFarsiNumber(discount)}٪`}
        {showDiscountTitle && ` تخفیف `}
      </p>
    </div>
  );
};

export default DiscountBadge;
